import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Edit2, Trash2, RotateCcw } from 'lucide-react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  canEdit: boolean;
  onEdit?: () => void;
  onDelete?: () => void;
  isOngoing?: boolean;
  onRevertToDraft?: () => void;
  title?: string;
}

export const RankingOptionsModal: React.FC<Props> = ({ isOpen, onClose, canEdit, onEdit, onDelete, isOngoing, onRevertToDraft, title = 'Opções do Ranking' }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.4)",
          backdropFilter: "blur(4px)",
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
        }}
        onClick={onClose}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          onClick={(e) => e.stopPropagation()}
          style={{
            width: "100%",
            maxWidth: "320px",
            backgroundColor: "#1A112C",
            backdropFilter: "blur(16px)",
            border: "1px solid rgba(255,255,255,0.2)",
            borderRadius: "12px",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: "16px 20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: '1px solid rgba(255,255,255,0.1)'
            }}
          >
            <h2 style={{ color: "white", fontSize: "18px", fontWeight: 600, margin: 0 }}>
              {title}
            </h2>
            <button
              onClick={onClose}
              style={{ background: "none", border: "none", color: "rgba(255,255,255,0.6)", cursor: "pointer", display: "flex" }}
            >
              <X size={20} />
            </button>
          </div>

          {/* Body */}
          <div style={{ padding: '8px', display: 'flex', flexDirection: 'column' }}>


            {canEdit && (
              <>
                <div style={{ height: '1px', background: 'rgba(255,255,255,0.1)', margin: '4px 8px' }}></div>
                
                <button style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '12px', background: 'transparent', border: 'none', color: 'white', textAlign: 'left', cursor: 'pointer', borderRadius: '8px', transition: 'background 0.2s' }} onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.05)'} onMouseOut={(e) => e.currentTarget.style.background = 'transparent'} onClick={() => { if(onEdit) onEdit(); onClose(); }}>
                  <Edit2 size={18} color="rgba(255,255,255,0.7)" />
                  <span style={{ fontSize: '15px' }}>Editar Nome/Foto</span>
                </button>
                
                {isOngoing && onRevertToDraft && (
                  <button style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '12px', background: 'transparent', border: 'none', color: '#ff9800', textAlign: 'left', cursor: 'pointer', borderRadius: '8px', transition: 'background 0.2s' }} onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255,152,0,0.1)'} onMouseOut={(e) => e.currentTarget.style.background = 'transparent'} onClick={() => { onRevertToDraft(); onClose(); }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 2v6h-6"></path><path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path><path d="M3 22v-6h6"></path><path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path></svg>
                    <span style={{ fontSize: '15px', fontWeight: 500 }}>Voltar para Rascunho</span>
                  </button>
                )}
                
                <button style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '12px', background: 'transparent', border: 'none', color: '#ff4d4f', textAlign: 'left', cursor: 'pointer', borderRadius: '8px', transition: 'background 0.2s' }} onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255,77,79,0.1)'} onMouseOut={(e) => e.currentTarget.style.background = 'transparent'} onClick={() => { if(onDelete) onDelete(); onClose(); }}>
                  <Trash2 size={18} />
                  <span style={{ fontSize: '15px', fontWeight: 500 }}>Excluir Competição</span>
                </button>

                <div style={{ height: '1px', background: 'rgba(255,255,255,0.1)', margin: '4px 8px' }}></div>

                <button style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '12px', background: 'transparent', border: 'none', color: '#ff9800', textAlign: 'left', cursor: 'pointer', borderRadius: '8px', transition: 'background 0.2s' }} onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255,152,0,0.1)'} onMouseOut={(e) => e.currentTarget.style.background = 'transparent'} onClick={() => { alert('Funcionalidade em desenvolvimento: Zerar Pontuação do Ciclo Atual'); onClose(); }}>
                  <RotateCcw size={18} color="#ff9800" />
                  <span style={{ fontSize: '15px', fontWeight: 500 }}>Zerar Pontuação (Ciclo)</span>
                </button>
              </>
            )}

          </div>
          
        </motion.div>
      </div>
    </AnimatePresence>
  );
};
